import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/plus-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-d5f57422")

_pushScopeId("data-v-d5f57422")
const _hoisted_1 = { class: "mylist" }
const _hoisted_2 = { class: "mylist-all-title-area" }
const _hoisted_3 = { class: "mylist-all-title-area-title" }
const _hoisted_4 = { class: "commonTextBodyStrong mylist-all-title-area-title-text" }
const _hoisted_5 = { class: "commonButtonText mylist-all-title-area-button-text" }
const _hoisted_6 = { class: "mylist-all-area-nothing-container" }
const _hoisted_7 = { class: "mylist-title-area" }
const _hoisted_8 = { class: "mylist-title-area-title" }
const _hoisted_9 = { class: "commonTextBodyStrong mylist-title-area-title-text" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "mylist-folder-append-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_11 = { class: "mylist-folder-append-button-text-container" }
const _hoisted_12 = { class: "commonButtonText mylist-folder-append-button-text" }
const _hoisted_13 = { class: "mylist-folder-area-nothing-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonHorizontalRecipeList = _resolveComponent("CommonHorizontalRecipeList")
  const _component_MyListFolderList = _resolveComponent("MyListFolderList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.mylistAllTitle), 1)
      ]),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectAllList(...args))),
        class: "mylist-all-title-area-button",
        style: _ctx.styleAllListButton
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.mylistAllReferenceTitle), 1)
      ], 4)
    ]),
    _createVNode(_component_CommonHorizontalRecipeList, {
      class: "mylist-all-area",
      style: _ctx.styleAllList,
      recipes: _ctx.allList,
      onOnClick: _ctx.selectRecipe
    }, null, 8, ["style", "recipes", "onOnClick"]),
    _createVNode("div", {
      class: "mylist-all-area-nothing",
      style: _ctx.styleAllListNothing
    }, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          innerHTML: _ctx.nothingMylistMessage,
          class: "commonTextCaption1 mylist-all-area-nothing-text"
        }, null, 8, ["innerHTML"])
      ])
    ], 4),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("span", _hoisted_9, _toDisplayString(_ctx.mylistTitle), 1)
      ])
    ]),
    _createVNode("div", {
      class: "mylist-folder-append",
      style: _ctx.styleAppendFolder
    }, [
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectAppendFolder(...args))),
        class: "mylist-folder-append-button"
      }, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.mylistAppendFolder), 1)
        ])
      ])
    ], 4),
    _createVNode(_component_MyListFolderList, {
      folderList: _ctx.displayFolderList,
      style: _ctx.styleFolderList,
      onOnClick: _ctx.selectFolder,
      onMoveFolder: _ctx.moveFolder
    }, null, 8, ["folderList", "style", "onOnClick", "onMoveFolder"]),
    _createVNode("div", {
      class: "mylist-folder-area-nothing",
      style: _ctx.styleFolderListNothing
    }, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", {
          innerHTML: _ctx.nothingFolderMessage,
          class: "commonTextCaption1 mylist-folder-area-nothing-text"
        }, null, 8, ["innerHTML"])
      ])
    ], 4)
  ]))
})